import template from "./billing_approval.html";
import controller from "./billing_approval.controller";
import "./billing_approval.scss";

let branchManagementBillingApprovalComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementBillingApprovalComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/billing_approval/billing_approval.component.js